import { service } from "."
import { jwtHeader } from "utils/jwtHeader"

export default {
  getOne: (id) => service.get(`/visitors/${id}`, jwtHeader()),
  // update: (id, data) => service.put(`/visitors/${id}`, data, jwtHeader()),
  workUpdate: (data) => service.put(`/weballs`, data, jwtHeader()),
  workDelete: (data) => service.delete(`/weballs`, { ...jwtHeader(), data }),
  getVisitorDatas: (data) =>
    service.post(`/showpublics/websearch`, data, jwtHeader()),
}
